/*
  About Form - about tab
*/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { clone } from 'lodash';

/* Formik and Yup */
import { Formik } from 'formik';
import * as Yup from 'yup';

import { toggleChangesModal } from 'data_system/resource_portal/actions/experienceActions';
import { t } from 'services/translation';

import DetailsForm from './DetailsForm';
import {
  DEFAULT_ONLINE_MAX_CAPACITY,
  DEFAULT_OFFLINE_MAX_CAPACITY,
} from './constants';

// TODO - propTypes

class DetailsContainer extends Component {
  constructor(props) {
    super(props);

    const { experience } = this.props;
    const { templateMaxCapacity } = experience;

    const onlineCapacity = templateMaxCapacity || DEFAULT_ONLINE_MAX_CAPACITY;
    const offlineCapacity = templateMaxCapacity || DEFAULT_OFFLINE_MAX_CAPACITY;

    this.validationSchema = Yup.object().shape({
      isOnline: Yup.boolean(),
      location: Yup.object().when('$isOnline', {
        is: true,
        then: Yup.object().nullable(),
        otherwise: Yup.object()
          .nullable()
          .required(t('PLEASE_SELECT_A_LOCATION')),
      }),
      lengthHours: Yup.number()
        .max(4, t('PLEASE_LIMIT_TO_4_HOURS_OR_LESS'))
        .required(t('PLEASE_ENTER_HOURS')),

      lengthMinutes: Yup.number()
        .when('lengthHours', {
          is: (val) => val === 4,
          then: Yup.number()
            .max(0, t('PLEASE_LIMIT_TO_4_HOURS_OR_LESS'))
            .required(),
          otherwise: Yup.number().required(),
        })
        .when('lengthHours', {
          is: (val) => val === 0,
          then: Yup.number()
            .min(15, t('LENGTH_MUST_BE_AT_LEAST_15_MINUTES'))
            .required(),
          otherwise: Yup.number().required(),
        }),

      maxCapacity: Yup.number()
        .nullable()
        .positive(t('PLEASE_ENTER_A_CAPACITY'))
        .required(t('PLEASE_ENTER_A_CAPACITY'))
        .when('$isOnline', {
          is: true,
          then: Yup.number().max(
            onlineCapacity,
            t(
              'CAPACITY_IS_LIMITED',
              `Capacity is limited to ${onlineCapacity} people`,
              {
                capacity: onlineCapacity,
              }
            )
          ),
          else: Yup.number().max(
            offlineCapacity,
            t(
              'CAPACITY_IS_LIMITED',
              `Capacity is limited to ${offlineCapacity} people`,
              {
                capacity: offlineCapacity,
              }
            )
          ),
        }),
      price: Yup.number()
        .nullable()
        .max(500, t('PRICE_CANNOT_EXCEED_500'))
        .required(t('PLEASE_ENTER_A_PRICE')),
      vendorMeetingUrl: Yup.string().when('$isOnline', {
        is: true,
        then: Yup.string().required(t('PLEASE_ADD_VIDEO_CONFERENCING_DETAILS')),
        otherwise: Yup.string().nullable(),
      }),
    });
  }

  onSubmitForm = (values, _actions) => {
    const apiValues = this.apiValues(values);
    this.props.handleSubmit({
      step: 'details',
      apiValues,
    });
  };

  apiValues = (rawValues) => {
    const newValues = this.validationSchema.cast(clone(rawValues));
    newValues.length =
      parseInt(rawValues.lengthHours) + parseInt(rawValues.lengthMinutes) / 60;
    newValues.price = parseInt(parseFloat(newValues.price) * 100);
    newValues.maxPeople = rawValues.isOnline ? 1 : rawValues.maxCapacity;
    newValues.locationId = rawValues.location && rawValues.location.id;
    return newValues;
  };

  initialValues = () => {
    const { experience, onlineMeeting } = this.props;
    // Default/initial values to populate form (new)
    let initialValues = {
      location: null,
      lengthHours: 1,
      lengthMinutes: 0,
      maxCapacity: null,
      price: null,
      isOnline: null,
      vendorMeetingUrl: null,
    };

    if (!experience) {
      return initialValues;
    }
    const { length, maxCapacity, pricingDefinitions, location, isOnline } =
      experience;
    const { vendorMeetingUrl } = onlineMeeting;
    const maxCap = maxCapacity === 1000 ? null : maxCapacity;

    const lengthHours = parseInt(length);
    const lengthMinutes = (parseFloat(length) % 1) * 60;
    initialValues = {
      location,
      lengthHours,
      lengthMinutes,
      isOnline,
      vendorMeetingUrl,
      maxCapacity: maxCap,
      price:
        pricingDefinitions.length > 0
          ? pricingDefinitions[0].price_cents / 100
          : null,
    };
    return initialValues;
  };

  render() {
    return (
      <Formik
        render={(formikProps) => (
          <DetailsForm {...formikProps} i18n={this.props.i18n} />
        )}
        initialValues={this.initialValues()}
        validationSchema={this.validationSchema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values, actions) => this.onSubmitForm(values, actions)}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const { experienceReducer } = state;
  return {
    experience: experienceReducer.experience,
    onlineMeeting: experienceReducer.onlineMeeting,
    experienceStepForm: experienceReducer.experienceStepForm,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ toggleChangesModal }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DetailsContainer));
